import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import * as projectMod from "./project/index";
import * as storeMod from "./store/index";
import * as mixinsMod from "./mixins/index";
import * as reportMod from "./report/index";
import * as busMod from "./bus/index";
import * as shareMod from "./share/index";
import * as styleMod from "./style/index";
import * as sentryMod from "./sentry/index";
import * as peckerMod from "./pecker/index";
import * as loggerMod from "./logger/index";
import * as monitorMod from "./monitor/index";
import * as mirrorMod from "./mirror/index";
export { executeOneInTime, sleep } from "./utils/componentHelper";
export var project = projectMod.project;
export var store = storeMod.store;
export var bus = busMod.bus;
export var debug = loggerMod.debug;
export var log = loggerMod.log;
export var monitor = monitorMod.monitor;
export { createModule } from "./store/createModule";
export default function setup(_x) {
  return _setup.apply(this, arguments);
}

function _setup() {
  _setup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var projectOptions, storeOptions, mixinOptions, reportOptions, busOptions, shareOptions, peckerOptions, sentryOptions, loggerOptions, mirrorOptions, styleOptions, monitorOptions;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            projectOptions = _ref.projectOptions, storeOptions = _ref.storeOptions, mixinOptions = _ref.mixinOptions, reportOptions = _ref.reportOptions, busOptions = _ref.busOptions, shareOptions = _ref.shareOptions, peckerOptions = _ref.peckerOptions, sentryOptions = _ref.sentryOptions, loggerOptions = _ref.loggerOptions, mirrorOptions = _ref.mirrorOptions, styleOptions = _ref.styleOptions, monitorOptions = _ref.monitorOptions;
            _context.prev = 1;
            _context.next = 4;
            return Promise.all([projectMod.setup(projectOptions), storeMod.setup(storeOptions), sentryMod.setup(sentryOptions), mixinsMod.setup(mixinOptions), reportMod.setup(reportOptions), busMod.setup(busOptions), shareMod.setup(shareOptions), peckerMod.setup(peckerOptions), loggerMod.setup(loggerOptions), mirrorMod.setup(mirrorOptions), styleMod.setup(styleOptions), monitorMod.setup(monitorOptions)]);

          case 4:
            console.log('vue-base setup success');
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            console.error('vue-base setup fail ', _context.t0);
            throw _context.t0;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));
  return _setup.apply(this, arguments);
}